import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../../common_comp/Layout/Layout";

function EthicsPolicy() {
  return (
    <>
     <Layout>
     <Container className="mt-5 px-4" >

     <Row className="g-5 pt-3">
            <Col lg={10} md={10} sm={12} className="mx-auto">
            <h2 className="fw-bold mb-4">Ethics and Publication Policy</h2>
            <p className="joab-common-para mb-3 text-dark">
              The Journal of Applied Bioanalysis is committed to maintaining the highest ethical standards in all aspects of the publication process. We strictly adhere to the guidelines and best practices recommended by the Committee on Publication Ethics  <a href="https://publicationethics.org" target="_blank" rel="noopener noreferrer">(COPE)</a> and the International Committee of Medical Journal Editors  <a href="http://www.icmje.org" target="_blank"  rel="noopener   noreferrer">(ICMJE)</a>.
            </p>

            <h4 className="fw-bold mb-3">1. Responsibilities of Authors</h4>

            <h5 className="fw-bold mb-2" >Originality and Plagiarism</h5>
            <p className="joab-common-para mb-3">
              Authors must ensure that their submitted work is entirely original and properly cited. Plagiarism in any form, including self-plagiarism, is unethical and unacceptable. All manuscripts are screened using plagiarism detection software.
            </p>

            <h5 className="fw-bold mb-2" >Multiple or Redundant Submission</h5>
            <p className="joab-common-para mb-3">
              Manuscripts must not be submitted to more than one journal simultaneously. Submitting the same paper to multiple journals constitutes unethical publishing behavior.
            </p>

            <h5 className="fw-bold mb-2" >Authorship</h5>
            <p className="joab-common-para mb-3">
              Authorship should be limited to those who have made significant contributions to the research. All contributors who meet authorship criteria must be listed, and those who do not should be acknowledged appropriately.
            </p>

            <h5 className="fw-bold mb-2" >Acknowledgment of Sources</h5>
            <p className="joab-common-para mb-3">
              Authors must acknowledge all sources of funding and clearly cite any previous work used to support the research.
            </p>

            <h5 className="fw-bold mb-2" >Conflicts of Interest</h5>
            <p className="joab-common-para mb-3">
              All authors must disclose any financial or other conflicts of interest that might influence the results or interpretation of the manuscript.
            </p>

            <h4 className="fw-bold mb-3" style={{marginTop: '2rem'}}>Ethical Approvals</h4>
            <p className="joab-common-para mb-3">
              Research involving human or animal subjects must include a statement of approval from the relevant ethics committee and confirmation that informed consent was obtained, where applicable. Authors must also confirm that any such studies were conducted in accordance with institutional guidelines and, where relevant, in compliance with the EU Directive 2010/63/EU on the protection of animals used for scientific purposes (<a href="https://ec.europa.eu/environment/chemicals/lab_animals/legislation_en.htm" target="_blank" rel="noopener noreferrer">European Commission</a>).
            </p>

            <h4 className="fw-bold mb-3" style={{marginTop: '2rem'}}>2. Responsibilities of Editors</h4>
            <h5 className="fw-bold mb-2" >Editorial Independence</h5>
            <p className="joab-common-para mb-3">
              Editors are responsible for the final decision on the publication of submitted manuscripts and act independently, without influence from the publisher or external institutions.
            </p>
            <h5 className="fw-bold mb-2" >Fair Evaluation</h5>
            <p className="joab-common-para mb-3">
              Editors must evaluate manuscripts based on intellectual content without regard to the authors' race, gender, religious belief, ethnic origin, citizenship, or political philosophy.
            </p>
            <h5 className="fw-bold mb-2" >Confidentiality</h5>
            <p className="joab-common-para mb-3">
              Editors must ensure the confidentiality of submitted manuscripts and will not disclose any information to anyone other than those involved in the editorial process.
            </p>
            <h5 className="fw-bold mb-2" >Conflict of Interest</h5>
            <p className="joab-common-para mb-3">
              Editors must recuse themselves from handling manuscripts where they have conflicts of interest resulting from relationships or connections with any of the authors, companies, or institutions connected to the paper.
            </p>

            <h4 className="fw-bold mb-3" style={{marginTop: '2rem'}}>3. Responsibilities of Reviewers</h4>
            <h5 className="fw-bold mb-2" >Confidentiality</h5>
            <p className="joab-common-para mb-3">
              Manuscripts received for review must be treated as confidential documents and not shared or discussed with others.
            </p>
            <h5 className="fw-bold mb-2" >Objectivity and Constructiveness</h5>
            <p className="joab-common-para mb-3">
              Reviews should be conducted objectively and constructively, avoiding personal criticism of the author.
            </p>
            <h5 className="fw-bold mb-2" >Promptness</h5>
            <p className="joab-common-para mb-3">
              Reviewers should notify the editor if they are unable to complete the review within the specified time.
            </p>
            <h5 className="fw-bold mb-2" >Acknowledgment of Sources</h5>
            <p className="joab-common-para mb-3">
              Reviewers must identify relevant published work that has not been cited by the authors and report any substantial similarity to previously published material.
            </p>

            <h4 className="fw-bold mb-3" style={{marginTop: '2rem'}}>4. Plagiarism Policy</h4>
            <p className="joab-common-para mb-3">
              The journal uses plagiarism detection tools to screen all submissions. If plagiarism is identified, the manuscript will be rejected or retracted, depending on the severity. The authors will be informed and given a chance to respond.
            </p>
            <p className="joab-common-para mb-3">
              <b>We define plagiarism as:</b><br/>
              - Copying text or ideas from other sources without proper citation<br/>
              - Using another author's work as one's own<br/>
              - Reusing parts of your own previously published work without citation (self-plagiarism)
            </p>
            <p className="joab-common-para mb-3">
              For more, refer to the COPE flowcharts: <a href="https://publicationethics.org/guidance/Flowcharts" target="_blank" rel="noopener noreferrer">https://publicationethics.org/guidance/Flowcharts</a>
            </p>

            <h4 className="fw-bold mb-3" style={{marginTop: '2rem'}}>5. Generative Artificial Intelligence (AI) Use Policy</h4>
            <p className="joab-common-para mb-3">
              The journal recognizes the increasing use of generative AI tools (e.g., ChatGPT, Bard, Claude). To ensure integrity:
            </p>

            <h5 className="fw-bold mb-2">5.1 Permitted Use</h5>
            <p className="joab-common-para mb-3">
              Authors may use AI tools only for:
              <br/>- Grammar correction
              <br/>- Language polishing
              <br/>- Formatting suggestions
            </p>

            <h5 className="fw-bold mb-2">5.2 Prohibited Use</h5>
            <p className="joab-common-para mb-3">
              AI tools must not be used to:
              <br/>- Generate scientific content
              <br/>- Write core sections (Results, Discussion, Abstract)
              <br/>- Generate references
              <br/>- Create data, images, or experimental results
            </p>

            <h5 className="fw-bold mb-2">5.3 Mandatory Disclosure</h5>
            <p className="joab-common-para mb-3">
              Any use of AI must be disclosed in the Acknowledgments, stating:
              <br/>- The tool used
              <br/>- The purpose
              <br/>- Confirmation that authors reviewed and verified all outputs
            </p>
            <p className="joab-common-para mb-3">
              <b>Example:</b><br/>
              "The authors used ChatGPT (OpenAI) for language editing. All content was reviewed and verified by the authors."
            </p>

            <h5 className="fw-bold mb-2">5.4 AI Cannot Be an Author</h5>
            <p className="joab-common-para mb-3">
              AI tools cannot be listed as authors. Only humans can be authors.
            </p>
            </Col>
          </Row>
      </Container>
     </Layout>
    </>
  );
}

export default EthicsPolicy; 
